import { FormInstance } from 'antd/lib/form';
import { useGetInvoiceNoQuery } from 'modules/Invoice(Visa)/Api/Endpoints/invoiceVisaEndpoints';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { FormFileInput, FormInput } from '../../../components/common/FormItem/FormItems';
import {
  SelectClients,
  SelectEmployee,
} from '../../../components/common/FormItem/SelectCustomFeilds';
import { ISelectClientDetails } from '../types/invoiceAirTicketTypes';
type Props = {
  form: FormInstance<any>;
};

export default function AirticketHeaderPDF({ form }: Props) {
  /* set ClientName instance when create new one */
  const [instanceClientsSelect, setInstanceClientSelect] = useState<number>();
  const [instanceAgnetSelect, _setInstanceAgentSelect] = useState<number>();
  const [instanceSalesEmpSelect, setInstanceSalesEmpSelect] = useState<number>();
  const { airticketInvoiceId } = useParams();

  useEffect(() => {
    if (instanceClientsSelect) {
      form.setFieldValue('invoice_combclient_id', 'client-' + instanceClientsSelect);
    } else if (instanceAgnetSelect) {
      form.setFieldValue('invoice_agent_id', instanceAgnetSelect);
    } else if (instanceSalesEmpSelect) {
      form.setFieldValue('invoice_sales_man_id', instanceSalesEmpSelect);
    }
  }, [instanceAgnetSelect, instanceSalesEmpSelect, instanceClientsSelect]);

  const [clientDetails, setClientDetails] = useState<ISelectClientDetails>();

  const getPrevFiledValue = form.getFieldValue('invoice_walking_customer_name');
  // @set invoice_no
  const { data: invoiceIdData, isLoading, isSuccess } = useGetInvoiceNoQuery('AIT');
  useEffect(() => {
    if (isSuccess) {
      form.setFieldValue('invoice_no', invoiceIdData?.data);
    }
  }, [invoiceIdData, isSuccess]);

  return (
    <>
      <SelectClients
        label='Search Client:'
        name='invoice_combclient_id'
        required
        size={24}
        mdSize={8}
        xsSize={5}
        smSize={12}
        disabled={!!airticketInvoiceId}
        setClientDetails={setClientDetails}
        setInstanceClientSelect={setInstanceClientSelect}
      />
      {(clientDetails?.client_walking_customer === 1 || getPrevFiledValue) && (
        <FormInput
          size={24}
          mdSize={8}
          smSize={12}
          label='Client Name'
          name='invoice_walking_customer_name'
        />
      )}
      <SelectEmployee
        size={24}
        label='Sales By:'
        name='invoice_sales_man_id'
        required
        setInstanceSalesEmpSelect={setInstanceSalesEmpSelect}
      />
      {/* <FormInputItem readOnly required label='Invoice No:' name='invoice_no' size={24} /> */}

      {/* <FileUploadPDF msg='Please Upload a PDF File' name='file' label='PDF File' /> */}
      <FormFileInput
        name='file'
        accept='application/pdf'
        label='File (Maximum Size 1 MB)'
        size={24}
        picture='picture'
      />
    </>
  );
}
